<template>
  <div>
    <router-view />
    <div class="q-pa-md q-mt-xl q-ml-lg" style="background-color:white;width:1230px;" :v-if="price">
    

      <div class="q-mt-sm" style="width:85%;margin-left:7%;">
        <h5>How to add product details?</h5>
        <ul style="font-size:15px">
          <li>
            First select the section among 3 available sections by clicking any where inside the box
          </li>
          <li>
            Download sample files by clicking on download button provided in each section

          </li>
          <li>
            Generate a file in csv format using the downloaded file as reference
            
          </li>
          <li>
            Browse the generated file by clicking on browse button 
            
          </li>
          <li>
            Upload the file by clicking on upload button
          </li>
        </ul>
        <p style="font-size:15px; font-style:italic"><span style="font-weight:500">Note :</span> you can select only one section</p>
      </div>


          
      <div class="introWindow">

         <div class="rows q-pa-md">
         <label class="labl">
        <input type="radio" name="radioname" checked="checked"/>
          <div class="columns row">
            <div class="cards col-auto">
              <div class="card-i">
                <img class="cardimg" src="../../assets/profit.png" />
                <q-tooltip>
                 price optimization for profit maximization
                </q-tooltip>

                <q-card-section style="text-decoration: none;"> Profit </q-card-section>
              </div>
            </div>
            <div class="text col-8 row">
              <div class="col-12 row ">
              <span  class="items col-3">Historical data</span>
              
              
              <q-btn class="col-2" color="secondary" text-color="white">
                <vue-blob-json-csv
                        title="Download"
                        file-type="csv"
                        file-name="historicalData"
                        :data="data2"
                        class="download"
                       
              >
             
              </vue-blob-json-csv>
             
              </q-btn>
             
              <label class="col-6 items">
              <input type="file" accept=".csv" id="file" ref="file" name="files" v-on:change="handleFileUpload1($event,'profit1')"/>
              
              
              </label>
              
              </div>
              <div class="col-12 row ">
              <span  class="col-3 items">Cost Details</span>
              
              
              <q-btn class="col-2" color="secondary" text-color="white">
                <vue-blob-json-csv
                        title="Download"
                        file-type="csv"
                        file-name="costDetails"
                        :data="data1"
                        class="download"
                       
              >
             
              </vue-blob-json-csv>
              
              </q-btn>
             
              <label class="col-6 items">
              <input type="file" accept=".csv" id="file" ref="file" name="files" v-on:change="handleFileUpload2($event,'profit2')"/>
              
              
              </label>
              
              </div>
               
            </div>

            <div class="col-2 radios">
              
              <div>  
                <q-radio v-model="model1" val="discount" label="Discount"></q-radio>
                <q-radio v-model="model1" val="abovemrp" label="Above MRP"></q-radio>
                <q-radio v-model="model1" val="both" label="Both"></q-radio>
                <div>
                <q-btn round  @click="alert = true"><img class="icon" src="../../assets/help.png" /></q-btn>
                </div>
                <!-- <div id="q-app" style="min-height: 100vh;"> -->
            <div class="q-pa-md q-gutter-sm">

              <q-dialog v-model="alert">
                <q-card>
                  <q-card-section>
                    <div class="text-h6">What is discounts, above MRP?</div>
                  </q-card-section>

                  <q-card-section class="q-pt-none">
                  <ul><li>Suggest me discounts for all the selected products</li>
                  <li>Help me to lift current MRP for all selected products</li>
                  <li>Suggest me optimal prices ( Discount or lifted MRP )</li></ul>
                  </q-card-section>
                  <q-card-actions align="right">
                    <q-btn flat label="OK" color="primary" v-close-popup></q-btn>
                  </q-card-actions>
                </q-card>
              </q-dialog>
            </div>
                <!-- <q-checkbox  value=true label="Above MRP" v-model="select"></q-checkbox> -->
                <!-- <q-checkbox  value=true label="Above MRP" v-model="select"></q-checkbox> -->
            
              </div>

            </div>

            <div class="row button">
                <q-btn class="glossy" color="deep-orange" label="SUBMIT" @click="upload_to_s3('profit',model1)">
                
              </q-btn>
             </div>
             
          </div>
         </label>

         

           <label class="labl">
        <input type="radio" name="radioname"/>
            <div class="columns row">
            <div class="cards col-auto">
              <div class="card-i">
                <img class="cardimg" src="../../assets/revenue.png" />
                <q-tooltip>
                 price optimization for profit maximization
                </q-tooltip>

                <q-card-section style="text-decoration: none;"> Revenue </q-card-section>
              </div>
            </div>
            <div class="text col-8 row">
              <div class="col-12 row ">
              <span  class="items col-3">Historical Data</span>
              
              
              <q-btn class="col-2" color="secondary" text-color="white">
                <vue-blob-json-csv
                        title="Download"
                        file-type="csv"
                        file-name="historicalData"
                        :data="data2"
                        class="download"
                       
              >
             
              </vue-blob-json-csv>
              
              </q-btn>
             
              <label class="col-6 items">
              <input type="file" accept=".csv" id="file" ref="file" name="files" v-on:change="handleFileUpload1($event,'revenue1')"/>
              
              
              </label>
              
              </div>
             
               
            </div>

            <div class="col-2 radios">
              
              <div>  
                <q-radio v-model="model2" val="discount" label="Discount"></q-radio>
                <q-radio v-model="model2" val="abovemrp" label="Above MRP"></q-radio>
                <q-radio v-model="model2" val="both" label="Both"></q-radio>
                <div>
                <q-btn round  @click="alert = true"><img class="icon" src="../../assets/help.png" /></q-btn>
                </div>
                <!-- <div id="q-app" style="min-height: 100vh;"> -->
            <div class="q-pa-md q-gutter-sm">

              <q-dialog v-model="alert">
                <q-card>
                  <q-card-section>
                    <div class="text-h6">What is discounts, above MRP?</div>
                  </q-card-section>

                  <q-card-section class="q-pt-none">
                  <ul><li>Suggest me discounts for all the selected products</li>
                  <li>Help me to lift current MRP for all selected products</li>
                  <li>Suggest me optimal prices ( Discount or lifted MRP )</li></ul>
                  </q-card-section>
                  <q-card-actions align="right">
                    <q-btn flat label="OK" color="primary" v-close-popup></q-btn>
                  </q-card-actions>
                </q-card>
              </q-dialog>
            </div>
                <!-- <q-checkbox  value=true label="Above MRP" v-model="select"></q-checkbox> -->
                <!-- <q-checkbox  value=true label="Above MRP" v-model="select"></q-checkbox> -->
            
              </div>

            </div>
            <div class="row button">
                <q-btn class="glossy" color="deep-orange" label="SUBMIT" @click="upload_to_s3('revenue',model2)">
                
              </q-btn>
             </div>
             
          </div>
           </label>

       <label class="labl">
        <input type="radio" name="radioname" />
      <div class="columns row">
            <div class="cards col-auto">
              <div class="card-i">
                <img class="cardimg" src="../../assets/volume.png" />
                <q-tooltip>
                 price optimization for profit maximization
                </q-tooltip>

                <q-card-section style="text-decoration: none;"> Volume </q-card-section>
              </div>
            </div>
            <div class="text col-8 row">
              <div class="col-12 row ">
              <span  class="items col-3">Historical data</span>
              
              
              <q-btn class="col-2" color="secondary" text-color="white">
                <vue-blob-json-csv
                        title="Download"
                        file-type="csv"
                        file-name="historicalData"
                        :data="data2"
                        class="download"
                       
              >
             
              </vue-blob-json-csv>
              
              </q-btn>
             
              <label class="col-6 items">
              <input type="file" accept=".csv" id="file" ref="file" name="files" v-on:change="handleFileUpload1($event,'volume1')"/>
              
              
              </label>
              
              </div>
              <div class="col-12 row ">
              <span  class="col-3 items">Stock details</span>
              
              
              <q-btn class="col-2" color="secondary" text-color="white">
                <vue-blob-json-csv
                        title="Download"
                        file-type="csv"
                        file-name="stockDetails"
                        :data="data"
                        class="download"
                       
              >
             
              </vue-blob-json-csv>
              
              </q-btn>
             
              <label class="col-6 items">
              <input type="file" accept=".csv" id="file" ref="file" name="files" v-on:change="handleFileUpload2($event,'volume2')"/>
              
              
              </label>
             
              </div>
               
            </div>

            
            <div class="row button">
                <q-btn class="glossy" color="deep-orange" label="SUBMIT" @click="upload_to_s3('volume',model3)">
                
              </q-btn>
             </div>
             
          </div>
       </label>

        </div>
        

       
      </div>
       
      
    </div>
  </div>
</template>

<script>

export default {

 
 
  computed:{
    profit(){
      return { path:'/priceoptimization/profit', query: {type:'profit'}};
    },
    revenue(){
      return {path:"/priceoptimization/revenue",query:{type:'revenue'}};
    },
    volume(){
      return {path:"/priceoptimization/volume",query:{type:'volume'}};
    }
  },
  data() {
    return {
      alert:false,
      price: window.location.pathname == "/priceoptimization",

      historicalData:["FIELD1","store_key","item_key","ingoing_stock_date","ingoing_stock"],
      costDetails:[ "FIELD1", "store_key", "item_key", "cost" ],
      stockDetails:[ "FIELD1", "store_key", "item_key", "ingoing_stock_date", "ingoing_stock" ],
      handle1:false,
      handle2:false,
      profit1:false,
      profit2:false,
      revenue1:false,
      volume1:false,
      volume2:false,

      model1:"discount",
      model2:"discount",
      model3:"discount",
      

      data:[
 {
   
   "store_key": "",
   "item_key": "",
   "ingoing_stock_date": "",
   "ingoing_stock": ""
 }
],
data1:[
 {
   
   "store_key": "",
   "item_key": "",
   "cost": ""
 }
],
data2:[
 
 {
   
   "date": "",
   "store_key": "",
   "item_key":"",
   "product_name":"",
   "sold_price_single_unit":"",
   "original_price": "",
   "quantity": "",
   
 },
 
 
 
],
      file:'',
      files:[],
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      
      
    };
  },
  mounted(){
      this.$q.loading.show({
       message: "Authenticating please wait..",
     });

      if(this.$cookies.isKey("login_authentication"))
     {
       let encryptedText = this.$cookies.get("login_authentication");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
          this.$store.dispatch("setPathName", "/priceoptimization/offline");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else if(this.$cookies.isKey("login_authentication1"))
     {
       let encryptedText = this.$cookies.get("login_authentication1");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
        this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else if(this.$cookies.isKey("login_authentication2"))
     {
       let encryptedText = this.$cookies.get("login_authentication2");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
          this.$store.dispatch("setPathName", "/priceoptimization/offline");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else{

       this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

     }

    },
  
  methods:{
    
    upload_to_s3(category,radioname){
      

                  if(category == "profit" && (this.profit1==false || this.profit2==false))
                  {
                    this.$alert("selected files are not proper, please check them and upload again.","Invalid file type!");
                    return;

                  }

                  if(category == "revenue" && (this.revenue1==false))
                  {
                    this.$alert("selected file is not proper, please check them and upload again.","Invalid file type!");
                    return;

                  }

                  if(category == "volume" && (this.volume1==false || this.volume2==false))
                  {
                    this.$alert("selected files are not proper, please check them and upload again.","Invalid file type!");
                    return;

                  }

                    var formData1 = new FormData();
                   
                   
                    
             
                      formData1.append('file1', this.files[0]);

                      console.log("this.files[0]");

                      console.log(this.files[0]);

                      formData1.append('file2', this.files[1]);
                      
                      console.log("this.files[1]");
                      console.log(this.files[1]);
                    
               
                    if(category == 'revenue')
                    {
                      formData1.append('file2', this.files[0]);
                    }
                    
                     
                    let headers = {
                            'Content-Type': 'multipart/form-data'
                        }

                      
                console.log("url started");
                let postURL = this.api_url + `/products/uploadfile/` + category + `/`+ radioname + `/`+ this.$org_id.label;

                console.log(postURL)
                this.$http
                .post(postURL,formData1,formData1)
                .then((response)=>{
                 
                     this.profit1 = false;
                     this.revenue1 = false;
                     this.volume1 = false;
                     this.profit2 = false;
                      this.volume2 = false;

                this.$alert("selected files have been uploaded.","Uploaded Successfully!");
            

              
          });

          
                    
    },
    handleFileUpload1(event,category){
                this.files[0] = event.target.files[0];
                console.log(this.files[0]);
                this.checkFile(this.files[0],category);
              
               
            },
          
    handleFileUpload2(event,category){
                this.files[1] = event.target.files[0];
                console.log(this.files[1]);
                
                this.checkFile(this.files[1],category);
            },

    checkFile(file,category){
      var headers='';
      
   
      var fr = new FileReader();
      fr.onload = function(e) {

          const str = e.target.result;
          console.log("str");
          console.log(str);
          headers = str.slice(0, str.indexOf("\n")).split(",");
          console.log("headers");
          console.log(headers);
          console.log(headers.toString())

          const rows = str.slice(str.indexOf("\n") + 1).split("\n");
          console.log("rows");
          console.log(rows);

         
     
          
          
            if("date,store_key,item_key,product_name,sold_price_single_unit,original_price,quantity\r" === headers.toString() || 
            "date,store_key,item_key,product_name,sold_price_single_unit,original_price,quantity" === headers.toString())
            {
               var bool=false;
               for(let i=0 ; i<rows.length-1 ; i++)
               {
                  if(rows[i] == ",,,,,," || rows[i] == "")
                  {
                    bool=true;

                    
                  }
               }

              console.log(bool);
              if(bool)
              {
                this.$q.notify({
                      message: "file is empty or not proper, please reupload non-empty file",
                      color: "grey-3",
                      textColor: "red",
                    });
                return ;
              }
              
               if(category == 'profit1')
               {
                 this.profit1 = true;
               }

               if(category == 'revenue1')
               {
                 this.revenue1 = true;
               }

               if(category == 'volume1')
               {
                 this.volume1 = true;
               }
              
            }

            if("store_key,item_key,cost\r"== headers.toString() ||
            "store_key,item_key,cost"== headers.toString())
            {
              var bool=false;
               for(let i=0 ; i<rows.length-1 ; i++)
                  if(rows[i] == ",," || rows[i] == "")
                  {
                    bool=true;

                    
                  }

              if(bool)
              {
                this.$q.notify({
                      message: "file is empty or not proper, please reupload non-empty file",
                      color: "grey-3",
                      textColor: "red",
                    });
                return ;
              }
              

              if(category == 'profit2')
               {
                 this.profit2 = true;
               }


            }

            if("store_key,item_key,ingoing_stock_date,ingoing_stock\r"== headers.toString() ||
            "store_key,item_key,ingoing_stock_date,ingoing_stock"== headers.toString())
            {
              var bool=false;
               for(let i=0 ; i<rows.length-1 ; i++)
                  if(rows[i] == ",,," || rows[i] == "")
                  {
                    bool=true;

                    
                  }

              if(bool)
              {
                this.$q.notify({
                      message: "file is empty or not proper, please reupload non-empty file",
                      color: "grey-3",
                      textColor: "red",
                    });
                return ;
              }
              

              if(category == 'volume2')
               {
                 this.volume2 = true;
               }


            }

       
      }.bind(this);
      fr.readAsText(file);

   
    },

  
  }
  
};
</script>

<style  scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");


/* Float four columns side by side */
span {
  font-size: 16px;
  font-weight: 500;
 
  
  
}
.columns {
 
  
  width:957px;
 
  height: 270px;
  box-shadow: rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 2px 3px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset;
  background-color:whitesmoke;
  margin: 50px auto;
  border-radius: 5px;
}





.items{
  display: flex;
  justify-content: center;
  align-items: center;
}

.download {
  font-size: 14px;
}



.cards {
  display: flex;
  margin-left: 20px;
  justify-content: center;
  align-items: center;
  
  
  
}


.button {
  align-items: center;
  margin:0 auto;
  
}




.radios{
 display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 40px;

}

.q-radio{
  width: 100%;
}

.text {
  

  align-items: center;
}

/* Style the counter cards */
.card-i {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 10px;
  padding: 16px;
  text-align: center;
  background-color:#d0d1d1;
  float: right;
  height: 130px;
  width: 130px;
 
  transition:all 500ms ease;
  
  
}
.card-i:hover{
  background-color: #bec0c0;
}

.cardimg {
  text-align: center;
  margin: auto;
  height: 3rem;
  width: 3rem;
  min-height: 50px;
  min-width: 50px;
  margin-top: 10px;
}

.icon {
  text-align: center;
  margin: auto;
  height: 1rem;
  width: 1rem;
  min-height: 15px;
  min-width: 15px;
  /*margin-top: 10px;*/
}

.introWindow {
  text-align: center;
  background: transparent;
  height: auto;
  
  margin-bottom: 100px;
}



.labl {
    display : block;
    
}
.labl > input{ /* HIDE RADIO */
    visibility: hidden; /* Makes input not-clickable */
    position: absolute; /* Remove input from document flow */
}
.labl > input + div{ /* DIV STYLES */
    cursor:pointer;
    border:2px solid transparent;
    pointer-events: none;
}
.labl > input:checked + div{ /* (RADIO CHECKED) DIV STYLES */
    background-color: rgb(209, 234, 248);
    border: 1px solid #cfce74;
    pointer-events: all;
}
</style>

